/* eslint-disable @typescript-eslint/no-explicit-any */
import { type AfterContentChecked, Component, EventEmitter, Input, Output } from '@angular/core';
import { Message } from './interfaces/message';
import { type MessageButton } from './interfaces/message-button';

@Component({
    selector: 'big-chat-core-bot-message',
    template: '',
    standalone: false,
})
export class ChatCoreBotMessageComponent implements AfterContentChecked {
    @Input() public message!: Message;
    @Input() public error?: boolean;
    @Output() public readonly messageSelect: EventEmitter<any> = new EventEmitter<any>();
    @Output() public readonly buttonClick: EventEmitter<any> = new EventEmitter<any>();
    @Output() public readonly errorButtonClick: EventEmitter<any> = new EventEmitter<any>();

    public isBot!: boolean;

    public ngAfterContentChecked(): void {
        this.isBot = this.checkForBot();
    }

    public checkForBot(): boolean {
        return Boolean(this.message.isBot);
    }

    public isPending(): boolean {
        return Boolean(this.message.isPending);
    }

    public hasErrors(): boolean {
        return Boolean(this.message.error);
    }

    public getMessage(): string | undefined {
        return this.message.text;
    }

    public getButtons(): any[] {
        if (this.message.buttons === undefined) {
            return [];
        }

        return this.message.buttons;
    }

    public onButtonClick(button: MessageButton): void {
        this.buttonClick.emit(button);
        this.message.buttons = [];
    }

    public onErrorButtonClick(message: Message): void {
        this.errorButtonClick.emit(message);
    }

    public getImage(): string {
        return this.message.image && !this.message.image.includes('www.youtube.com') ? this.message.image : '';
    }

    public getVideo(): string {
        return this.message.image?.includes('www.youtube.com') ? this.message.image.replace('watch?v=', 'embed/') : '';
    }
}
